import { useEffect, useState } from "react";
import { getAllOperadores } from "components-base/operadores/functions";
import { getAllPickups } from "./functions";
import TabComponent from "components-base/Tab/Tab";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Box, Paper } from "@mui/material";
import PickupsTable from "./components/PickupsTable";
const DriverLogs = () => {
  const [drivers, setDrivers] = useState([]);
  const [logs, setLogs] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [tabs, setTabs] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());

  useEffect(() => {
    const fetchData = async () => {
      let operadores = await getAllOperadores();
      const drivers = operadores.filter((item) => item.activo === true);
      setDrivers(drivers);
      let logs = await getAllPickups(moment(selectedDate).format("YYYY-MM-DD"));
      setLogs(logs);
    };
    fetchData();
  }, [refresh]);

  useEffect(() => {
    let tabsArray = drivers
      .filter((driver) => !driver.codigo?.startsWith("ALM") && !driver.codigo?.startsWith("ADM"))
      .map((driver) => ({
        label: `${driver.persona.nombre} ${driver.persona.apellidoPaterno} ${driver.persona.apellidoMaterno}`,
        component: (
          <PickupsTable
            key={driver.id}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setRefresh={setRefresh}
            refresh={refresh}
            data={logs.filter((item) => item.driver.id === driver.id)}
          />
        ),
      }));
    setTabs(tabsArray);
  }, [logs, drivers]);
  const handleChangeDate = (value) => {
    setSelectedDate(moment(value));
    setRefresh(!refresh);
  };

  return (
    <Paper elevation={5}>
      <Box item xs={12} sm={12} md={8} style={{ padding: 20 }}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es-mx">
          <DatePicker
            label={"Filtro por fecha"}
            value={selectedDate}
            onChange={handleChangeDate}
          />
        </LocalizationProvider>
      </Box>
      <TabComponent tabsElement={tabs} />
    </Paper>
  );
};
export default DriverLogs;
